/**
 * 시스템 > 동기화 현황 > 동기화 현황 Store
 *
 * @since 2018-10-10
 * @author devp018
 */

import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'
import {getCodeJsonRow} from '~/utils/device-common'

export const state = () => ({
  apiUrl: {
    syncDevice: `${apiPrefix}/sync/device`, // 동기화 대상 장비 목록 조회 API
    syncMenu: `${apiPrefix}/sync/menu`, // 동기화 대상 기능/메뉴 목록 조회 API
    menu: `${apiPrefix}/menu` // 메뉴 목록 조회 API
  },
  // configUrl: `${apiPrefix}/sync/config`, // 동기화 설정 조회 API
  syncTypeOptions: [],
  syncStatusOptions: [],
  syncDeviceList: [], // 동기화 대상 장비 목록
  syncDeviceDetailList: [], // 동기화 대상 장비 상세 목록
  syncMenuList: [], // 동기화 대상 기능/메뉴 목록
  syncMenuDetailList: [], // 동기화 대상 기능/메뉴 상세 목록
  menuList: [] // 메뉴 목록,
})

export const mutations = {
  init (state) {
    state.syncTypeOptions = []
    state.syncStatusOptions = []
    state.syncDeviceList = []
    state.syncDeviceDetailList = []
    state.syncMenuList = []
    state.syncMenuDetailList = []
    state.menuList = []
  },
  setOptions (state) {
    // 동기화 유형 (1: 설정 동기화, 2: 설정 가져오기)
    state.syncTypeOptions = _.map(getCodeJsonRow('sync_type'), (item) => {
      return { value: item.key, label: item.val }
    })
    // 동기화 상태 유형 (0: 대기 중, 1: 진행 중, 99: 실패, 100: 완료)
    state.syncStatusOptions = _.map(getCodeJsonRow('sync_status_type'), (item) => {
      return { value: item.key, label: item.val }
    })
  },
  // 동기화 대상 장비 목록 설정
  setSyncDeviceList (state, data) {
    state.syncDeviceList = _.cloneDeep(data)
  },
  clearSyncDeviceDetailList (state) {
    state.syncDeviceDetailList = []
  },
  // 동기화 대상 장비 상세 목록 설정
  setSyncDeviceDetailList (state, data) {
    state.syncDeviceDetailList = _.map(data, items => {
      _.update(items, 'sync_status_type', (val) => {
        return (val !== 0 && val !== 1 && val !== 100) ? 99 : val
      })
      _.update(items, 'sync_err_set', (val) => {
        try {
          return !_.isNull(val) ? JSON.parse(val)[0].message : val
        } catch (e) {
          return val
        }
      })
      return items
    })
  },
  // 동기화 대상 기능/메뉴 목록 설정
  setSyncMenuList (state, data) {
    state.syncMenuList = _.cloneDeep(data)
  },
  clearSyncMenuDetailList (state) {
    state.syncMenuDetailList = []
  },
  // 동기화 대상 기능/메뉴 상세 목록 설정
  setSyncMenuDetailList (state, data) {
    state.syncMenuDetailList = _.map(data, items => {
      _.update(items, 'sync_status_type', (val) => {
        return (val !== 0 && val !== 1 && val !== 100) ? 99 : val
      })
      _.update(items, 'sync_err_set', (val) => {
        try {
          return !_.isNull(val) ? JSON.parse(val)[0].message : val
        } catch (e) {
          return val
        }
      })
      return items
    })
  },
  // 메뉴 목록 설정
  setMenuList (state, data) {
    state.menuList = _.cloneDeep(data.menu)
  }
}

export const actions = {
  // 동기화 대상 장비 목록 조회
  async getSyncDeviceList ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrl.syncDevice, { loading: false, successAlert: false })
    if (code === 'ok') {
      commit('setSyncDeviceList', result)
      return true
    }
    return false
  },
  // 동기화 대상 장비 상세 목록 조회
  async getSyncDeviceDetailList ({commit, state}, detailNo) {
    const res = { code: 'ok', result: {} }
    try {
      const {code, result} = await this.$axios.$get(state.apiUrl.syncDevice + '/' + detailNo)
      if (code === 'ok') {
        commit('setSyncDeviceDetailList', result)
        return {code, result}
      }
      return {code, result}
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 동기화 대상 기능/메뉴 목록 조회
  async getSyncMenuList ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrl.syncMenu, { loading: false, successAlert: false })
    if (code === 'ok') {
      commit('setSyncMenuList', result)
      return true
    }
    return false
  },
  // 동기화 대상 기능/메뉴 상세 목록 조회
  async getSyncMenuDetailList ({commit, state}, {menuId, syncType}) {
    const res = { code: 'ok', result: {} }
    try {
      const {code, result} = await this.$axios.$get(`${state.apiUrl.syncMenu}/${menuId}`, {
        params: { sync_type: syncType }
      })

      if (code === 'ok') commit('setSyncMenuDetailList', result)
      return {code, result}
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 메뉴 목록 조회
  async getMenuList ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrl.menu, { loading: false, successAlert: false })
    if (code === 'ok') {
      commit('setMenuList', result)
      return true
    }
    return false
  }
}

export const getters = {
}

export const strict = false
